module.exports = __webpack_public_path__ + "static/media/DriverVerification.838a5983.svg";